import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import EditMfrSeedForm from '../components/EditMfrSeedForm';

const EditMfrSeedPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    if (!id) {
      console.error('No seed ID found in URL! Redirecting...');
      window.location.href = `${window.location.origin}/admin/manufacturer_management?activeTab=2`;
    }
  }, [id]);

  const handleSuccess = () => {
    window.location.href = `${window.location.origin}/admin/manufacturer_management?activeTab=2`;
  };

  return id ? <EditMfrSeedForm id={id} onSuccess={handleSuccess} /> : null;
};

export default EditMfrSeedPage;
